import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CurrencyInput from 'react-currency-input';
import { maskValue, maskEmail, maskName } from '../maskUtils';

export default class CustomerFullDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      showFullCustomerDetails: false,
      data: props.data || null,
      pricing_mile_fixed_price_in_pence_1: props.data.
        pricing_mile_fixed_price_in_pence_1,
      pricing_mile_fixed_price_in_pence_2: props.data.
        pricing_mile_fixed_price_in_pence_2,
      pricing_mile_fixed_price_in_pence_3: props.data.
        pricing_mile_fixed_price_in_pence_3,
      pricing_mile_fixed_price_in_pence_4: props.data.
        pricing_mile_fixed_price_in_pence_4,
      value_of_jobs_per_invoice_in_pence: props.data.
        value_of_jobs_per_invoice_in_pence,
      value_of_jobs_per_invoice_in_pence_formatted: null,
      can_be_invoiced_by_scv: props.data.
        can_be_invoiced_by_scv,
      can_be_invoiced_by_acv: props.data.
        can_be_invoiced_by_acv,
      can_be_invoiced_by_bvl: props.data.
        can_be_invoiced_by_bvl,
      can_be_invoiced_by_cnd: props.data.
        can_be_invoiced_by_cnd,
      can_be_invoiced_by_acvtruck: props.data.
        can_be_invoiced_by_acvtruck,
      is_customer_archived: props.data.is_customer_archived || 0,
      showStaffUsers:false,
      editingField: null,
      editedValues: {},
    };
    this.handleShowStaff = this.handleShowStaff.bind(this)
  }
  handleChecked(e){
    let isChecked = e.target.checked;
    this.setState({is_customer_archived:(isChecked) ? 1 : 0});
  }
  handleShowStaff(e){
      e.preventDefault() 
      this.setState({showStaffUsers : !this.state.showStaffUsers});
  }
  showPricingHistory(e){
    e.preventDefault();
    window.open("/portal-admin/customer/pricing-history/" + this.state.data.id, "_blank");
  }

  showCustomerAllUsers(e) {
    e.preventDefault();
    window.open("/portal-admin/customers/" + this.state.data.id+ "/users", "_blank");
  }
  // handleChecked_pod(e){
  //   let isChecked = e.target.checked;
  //   this.setState({customer_needs_expenses_pod:(isChecked) ? 'pod' : 0});
  // }
  // handleChecked_poc(e){
  //   let isChecked = e.target.checked;
  //   this.setState({customer_needs_expenses_poc:(isChecked) ? 'poc' : 0});
  // }
  // handleChecked_fuel(e){
  //   let isChecked = e.target.checked;
  //   this.setState({customer_needs_expenses_fuel:(isChecked) ? 'fuel' : 0});
  // }
  // handleChecked_all(e){
  //   let isChecked = e.target.checked;
  //   this.setState({customer_needs_expenses_all:(isChecked) ? 'expense' : 0});
  // }
  saveChangesToCustomer(e) {
    e.preventDefault();
    let customer = "#customer-full-details-container-"+this.state.data.id+' ';

    let customerData = {
      api_token: window.api_token,
      editing: true,
      is_customer_archived:this.state.is_customer_archived,
      customer_disclaimer:document.querySelector(customer+'[name=customer_disclaimer]').value,
      // driver_video_link:document.querySelector(
      //   customer+
      //   '[name=driver_video_link]'
      // ).value,
      name: document.querySelector(
        customer+
        '[name=customer_name]'
      ).value,
      customer_approved: document.querySelector(
        customer+
        '[name=customer_approved]'
      ).value,
      vat_number: document.querySelector(
        customer+
        '[name=customer_vat_number]'
      ).value,
      reg_number: document.querySelector(
        customer+
        '[name=customer_reg_number]'
      ).value,
      telephone_1: this.state.editedValues.telephone_1 ??
        this.state.data.telephone_1,
      telephone_2: this.state.editedValues.telephone_2 ??
        this.state.data.telephone_2,
      sage_account_reference: document.querySelector(
        customer+
        '[name=customer_sage_account_reference]'
      ).value,
      contact_first_name: this.state.editedValues.contact_name ??
        this.state.data.contact_name,
      contact_last_name: ' ',
      contact_email: this.state.editedValues.contact_email ??
        this.state.data.contact_email,
      contact_telephone_1: this.state.editedValues.telephone_1 ??
        this.state.data.telephone_1,
      contact_telephone_2: this.state.editedValues.telephone_2 ??
        this.state.data.telephone_2,
      customer_special_instruction: document.querySelector(
        customer+
        '[name=customer_special_instruction]'
      ).value,
      add_multiple_email_addresses_of_people: document.querySelector(
        customer+
        '[name=add_multiple_email_addresses_of_people]'
      ).value,
      main_address: {
        postcode: document.querySelector(
          customer+
          '[name=customer_main_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          customer+
          '[name=customer_main_address_house_number_or_name]'
        ).value,
        address_line_1: this.state.editedValues.main_address?.address_line_1 ??
          this.state.data.main_address?.address_line_1 ?? '',
        address_line_2: this.state.editedValues.main_address?.address_line_2 ??
          this.state.data.main_address?.address_line_2 ?? '',
        address_line_3: this.state.editedValues.main_address?.address_line_3 ??
          this.state.data.main_address?.address_line_3 ?? '',
        town_city: document.querySelector(
          customer+
          '[name=customer_main_address_town_city]'
        ).value,
        county_area: document.querySelector(
          customer+
          '[name=customer_main_address_county_area]'
        ).value,
        country: document.querySelector(
          customer+
          '[name=customer_main_address_country]'
        ).value,
      },
      invoice_address: {
        postcode: document.querySelector(
          customer+
          '[name=customer_invoice_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          customer+
          '[name=customer_invoice_address_house_number_or_name]'
        ).value,
        address_line_1: this.state.editedValues.invoice_address?.address_line_1 ??
          this.state.data.invoice_address?.address_line_1 ?? '',
        address_line_2: this.state.editedValues.invoice_address?.address_line_2 ??
          this.state.data.invoice_address?.address_line_2 ?? '',
        address_line_3: this.state.editedValues.invoice_address?.address_line_3 ??
          this.state.data.invoice_address?.address_line_3 ?? '',
        town_city: document.querySelector(
          customer+
          '[name=customer_invoice_address_town_city]'
        ).value,
        county_area: document.querySelector(
          customer+
          '[name=customer_invoice_address_county_area]'
        ).value,
        country: document.querySelector(
          customer+
          '[name=customer_invoice_address_country]'
        ).value,
      },
      apprisal_required_from_driver_app: document.querySelector(
        customer+
        '#manual-appraisal-required-from-driver-app-form-radio-container '+
        'label.active [name=apprisal_required_from_driver_app]'
      ).value,
      manual_appraisal_required: document.querySelector(
        customer+
        '#manual-appraisal-required-form-radio-container '+
        'label.active [name=manual_appraisal_required]'
      ).value,
      video_appraisal_required: document.querySelector(
        customer+
        '#video-appraisal-required-form-radio-container '+
        'label.active [name=video_appraisal_required]'
      ).value,
      appraisal_to_be_done_on_external_system: document.querySelector(
        customer+
        '#appraisal-to-be-done-on-external-system-form-radio-container '+
        'label.active [name=appraisal_to_be_done_on_external_system]'
      ).value,
      name_of_external_system_for_appraisal: document.querySelector(
        customer+
        '[name=name_of_external_system_for_appraisal]'
      ).value,
      collect_signature: document.querySelector(
        customer+
        '#collect-signature-form-radio-container label.active '+
        '[name=collect_signature]'
      ).value,
      new_job_defaults_fleet_paperwork_required: document.querySelector(
        customer+
        '#fleet-paperwork-form-radio-container label.active '+
        '[name=vehicle_fleet_paperwork_required]'
      ).value,
      new_job_defaults_jet_wash_required: document.querySelector(
        customer+
        '#jet-wash-form-radio-container label.active '+
        '[name=vehicle_jet_wash_required]'
      ).value,
      new_job_defaults_driver_fuel_expense_included_in_job_price: document.
      querySelector(
        customer+
        '#driver-fuel-expense-included-in-job-price-form-radio-container '+
        'label.active [name=driver_fuel_expense_included_in_job_price]'
      ).value,
      new_job_defaults_customer_provides_fuel_cost: document.
      querySelector(
        customer+
        '#customer-provides-fuel-cost-form-radio-container '+
        'label.active [name=customer_provides_fuel_cost]'
      ).value,
      new_job_defaults_customer_provides_mileage: document.querySelector(
        customer+
        '#customer-provides-mileage-form-radio-container label.active '+
        '[name=customer_provides_mileage]'
      ).value,
      new_job_defaults_customer_provides_job_price: document.querySelector(
        customer+
        '#customer-provides-job-price-form-radio-container label.active '+
        '[name=customer_provides_job_price]'
      ).value,
      new_job_defaults_job_price_rounded_up: document.querySelector(
        customer+
        '#job-price-rounded-up-form-radio-container label.active '+
        '[name=job_price_rounded_up]'
      ).value,
      new_job_defaults_customer_needs_expenses: {
        pod: (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_pod]')) ? (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_pod]').value) : '',
        poc: (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_poc]')) ? (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_poc]').value) : '',
        fuel: (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_fuel]')) ? (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_fuel]').value) : '',
        all_expense: (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_all]')) ? (document.querySelector(customer+'#customer-needs-expenses-form-radio-container label.active  '+'[name=customer_needs_expenses_all]').value) : '',
      },
      customer_vat_code: (document.querySelector(customer+'#customer-vat-code-form-radio-container label.active '+'[name=customer_vat_code]')) ? 
      (document.querySelector(customer+'#customer-vat-code-form-radio-container label.active '+'[name=customer_vat_code]').value) : null,
      pricing_mile_start_1: document.querySelector(
        customer+
        '[name=pricing_mile_start_1]').value,
      pricing_mile_start_2: document.querySelector(
        customer+
        '[name=pricing_mile_start_2]').value,
      pricing_mile_start_3: document.querySelector(
        customer+
        '[name=pricing_mile_start_3]').value,
      pricing_mile_start_4: document.querySelector(
        customer+
        '[name=pricing_mile_start_4]').value,
      pricing_mile_end_4: document.querySelector(
        customer+
        '[name=pricing_mile_end_4]').value,
      pricing_mile_end_2: document.querySelector(
        customer+
        '[name=pricing_mile_end_2]').value,
      pricing_mile_end_3: document.querySelector(
        customer+
        '[name=pricing_mile_end_3]').value,
      pricing_mile_end_1: document.querySelector(
        customer+
        '[name=pricing_mile_end_1]').value,
      pricing_mile_pence_1: document.querySelector(
        customer+
        '[name=pricing_mile_pence_1]').value,
      pricing_mile_pence_2: document.querySelector(
        customer+
        '[name=pricing_mile_pence_2]').value,
      pricing_mile_pence_3: document.querySelector(
        customer+
        '[name=pricing_mile_pence_3]').value,
      pricing_mile_pence_4: document.querySelector(
        customer+
        '[name=pricing_mile_pence_4]').value,

      pricing_mile_fixed_price_in_pence_1: this.
        state.pricing_mile_fixed_price_in_pence_1,
      pricing_mile_fixed_price_in_pence_2: this.
        state.pricing_mile_fixed_price_in_pence_2,
      pricing_mile_fixed_price_in_pence_3: this.
        state.pricing_mile_fixed_price_in_pence_3,
      pricing_mile_fixed_price_in_pence_4: this.
        state.pricing_mile_fixed_price_in_pence_4,


      can_be_invoiced_by_scv: document.querySelector(
        customer+
        '#can-be-invoiced-by-scv-form-radio-container '+
        'label.active [name=can_be_invoiced_by_scv]'
      ).value,
      can_be_invoiced_by_bvl: document.querySelector(
        customer+
        '#can-be-invoiced-by-bvl-form-radio-container '+
        'label.active [name=can_be_invoiced_by_bvl]'
      ).value,
      can_be_invoiced_by_cnd: document.querySelector(
        customer+
        '#can-be-invoiced-by-cnd-form-radio-container '+
        'label.active [name=can_be_invoiced_by_cnd]'
      ).value,
      can_be_invoiced_by_acv: document.querySelector(
        customer+
        '#can-be-invoiced-by-acv-form-radio-container '+
        'label.active [name=can_be_invoiced_by_acv]'
      ).value,
      can_be_invoiced_by_g4: document.querySelector(
        customer+
        '#can-be-invoiced-by-g4-form-radio-container '+
        'label.active [name=can_be_invoiced_by_g4]'
      ).value,
      can_be_invoiced_by_acvtruck: document.querySelector(
        customer+
        '#can-be-invoiced-by-acvtruck-form-radio-container '+
        'label.active [name=can_be_invoiced_by_acvtruck]'
      ).value,

      value_of_jobs_per_invoice_in_pence: this.state.
        value_of_jobs_per_invoice_in_pence,

      number_of_jobs_per_invoice: document.querySelector(
        customer+
        '[name=number_of_jobs_per_invoice]').value,
      auto_subscriber_email: document.querySelector(
        customer+
        '[name=auto_subscriber_email]').value,
    };

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/customers/edit-customer/'+this.state.data.id,
      data: customerData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html(
            'Customer Changes Saved'
          );
          $('#infomodal .modal-body').html(
            'Changes saved to Customer'
          );
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html(
            'Error saving changes to customer information'
          );
          $('#infomodal .modal-body').html(
            $.parseHTML(
              response.responseText.replace(
                /\"/g, "")
            )
          );
          $('#infomodal').modal();
        }
      }
    });
  }

  render() {
    return (
      <div
        className="customers-table-row customer-full-details"
        id={
          "customer-full-details-"+
          this.state.data.id
        }
        key={
          "customer-full-details-"+
          this.state.data.id
        }>
        <form
          id={
            "customer-full-details-container-"+
            this.state.data.id
          }
        >
          <fieldset>
            <div className="row">
              <div className="col-md-3 text-left">
                <h3 className="text-center">
                  Customer Main Info
                </h3>
                <p>
                  Portal Customer ID: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_portal_id"
                  readOnly
                  value={
                    this.state.data.id
                  } />
                </p>
                <p>
                  Added to system on: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_added_to_system_on"
                  readOnly
                  value={
                    this.state.data.created_at
                  } />
                </p>
                <p>
                  Company Name: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_name"
                  defaultValue={
                    this.state.data.name
                  } />
                </p>
                <p>
                  Customer Telephone 1: {" "}
                  {window.hideSensitiveInfo ? (
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_telephone_1"
                      defaultValue={
                        this.state.data.telephone_1
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            telephone_1: e.target.value,
                          },
                        })
                      } />
                  ) : (
                  <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_telephone_1"
                  value={
                    maskValue(this.state.data.telephone_1, 2)
                  }
                  readOnly={true} />
                )}
                </p>
                <p>
                  Customer Telephone 2: {" "}
                  {window.hideSensitiveInfo ? (
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_telephone_2"
                      defaultValue={
                        this.state.data.telephone_2
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            telephone_2: e.target.value,
                          },
                        })
                      } />
                  ) : (
                  <>
                  {this.state.editingField !== "telephone_2" ? (
                    <span
                      className="form-control form-control-lg"
                      name="customer_telephone_2"
                      style={{ cursor: "pointer", display: "block" }}
                      onClick={() => this.setState({ editingField: "telephone_2" })}
                    >
                      {maskValue(this.props.data.telephone_2)}
                    </span>
                  ) : (
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_telephone_2"
                      value={
                        this.state.editedValues.telephone_2 ??
                        this.props.data.telephone_2 ?? ""
                      }
                      autoFocus
                      onChange={(e) =>
                        this.setState({
                          editedValues: {
                            ...this.state.editedValues,
                            telephone_2: e.target.value,
                          },
                        })
                      }
                      onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.setState({ editingField: null });
                          }
                          if (e.key === "Escape") {
                            this.setState({ editingField: null });
                          }
                        }}
                    />
                  )}
                  </>
                )}
                </p>
                <p>
                  Customer SAGE Account Reference: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_sage_account_reference"
                  defaultValue={
                    this.state.data.sage_account_reference
                  } />
                </p>
                <p>
                  Customer VAT Number: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_vat_number"
                  defaultValue={
                    this.state.data.vat_number
                  } />
                </p>
                <p>
                  Customer Reg Number: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_reg_number"
                  defaultValue={
                    this.state.data.reg_number
                  } />
                </p>
              </div>
              <div className="col-md-3 ">
                <h3>Customer Contact Info</h3>
                <p>
                  Name: {" "}
                  {window.hideSensitiveInfo ? (
                     <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_contact_name"
                      defaultValue={
                        this.state.data.contact_name
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            contact_name: e.target.value,
                          },
                        })
                      } />
                  ) : (
                    <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_contact_name"
                  value={
                    maskName(this.state.data.contact_name)
                  }
                  readOnly={true} />
                  )}
                </p>
                <p>
                  Email: {" "}
                  {window.hideSensitiveInfo ? (
                     <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_contact_email"
                      defaultValue={
                        this.state.data.contact_email
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            contact_email: e.target.value,
                          },
                        })
                      } />
                  ) : (
                    <input
                  type="text"
                  name="customer_contact_email"
                  className="form-control form-control-lg"
                  value={
                    maskEmail(this.state.data.contact_email)
                  }
                  readOnly={true} />
                  )}
                </p>
                <p>
                  Telephone 1: {" "}
                   {window.hideSensitiveInfo ? (
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_telephone_1"
                      defaultValue={
                        this.state.data.telephone_1
                      }
                       onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            telephone_1: e.target.value,
                          },
                        })
                      } />
                  ) : (
                  <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_contact_telephone_1"
                  value={
                    maskValue(this.state.data.telephone_1, 2)
                  }
                  readOnly={true} />
                  )}
                </p>
                <p>
                  Telephone 2: {" "}
                  {window.hideSensitiveInfo ? (
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_telephone_2"
                      defaultValue={
                        this.state.data.telephone_2
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            telephone_2: e.target.value,
                          },
                        })
                      } />
                  ) : (
                  <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_contact_telephone_2"
                  value={
                    maskValue(this.state.data.telephone_2, 2)
                  }
                  readOnly={true} />
                  )}
                </p>
                <p>
                  Special Instruction: 
                  <textarea className="form-control form-control-lg"
                        name="customer_special_instruction"
                        id="customer_special_instruction"
                        defaultValue={this.state.data.customer_special_instruction}>
                  </textarea>
                </p>
                <p>
                Multiple email addresses for bulk send POD/POC/Expenses: 
                  <textarea className="form-control form-control-lg"
                        name="add_multiple_email_addresses_of_people"
                        id="add_multiple_email_addresses_of_people"
                        defaultValue={this.state.data.add_multiple_email_addresses_of_people}>
                  </textarea>
                </p>
                  <p>Please separate different email address with comma(,)</p>
                <p>
                  Auto Subscribe Emails::
                  <textarea className="form-control form-control-lg"
                    name="auto_subscriber_email"
                    id="auto_subscriber_email"
                    defaultValue={this.state.data.auto_subscriber_email}>
                  </textarea>
                </p>  
                <p>Please separate different email address with comma(,)(,)</p>
              </div>
              <div className="col-md-3 ">
                <h3>Main address</h3>
                <p>
                  House Number or Name: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_main_address_house_number_or_name"
                  defaultValue={
                    this.state.data.main_address.house_number_or_name
                  } />
                </p>
                <p>
                  Address Line 1: {" "}
                  {window.hideSensitiveInfo ? (
                     <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_main_address_address_line_1"
                      defaultValue={
                        this.state.data.main_address.address_line_1
                      }
                       onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            main_address: {
                              ...(this.state.data.main_address || {}),
                              address_line_1: e.target.value,
                            },
                          },
                        })
                      } />
                  ) : (
                    <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_main_address_address_line_1"
                  value={
                    maskName(this.state.data.main_address.address_line_1)
                  }
                  readOnly={true} />
                  )}
                </p>
                <p>
                  Address Line 2: {" "}
                  {window.hideSensitiveInfo ? (
                     <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_main_address_address_line_2"
                      defaultValue={
                        this.state.data.main_address.address_line_2
                      }
                       onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            main_address: {
                              ...(this.state.data.main_address || {}),
                              address_line_2: e.target.value,
                            },
                          },
                        })
                      } />
                  ) : (
                    <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_main_address_address_line_2"
                  value={
                    maskName(this.state.data.main_address.address_line_2)
                  }
                  readOnly={true} />
                  )}
                </p>
                <p>
                  Address Line 3: {" "}
                  {window.hideSensitiveInfo ? (
                     <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_main_address_address_line_3"
                      defaultValue={
                        this.state.data.main_address.address_line_3
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            main_address: {
                              ...(this.state.data.main_address || {}),
                              address_line_3: e.target.value,
                            },
                          },
                        })
                      } />
                  ) : (
                    <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_main_address_address_line_3"
                  value={
                    maskName(this.state.data.main_address.address_line_3)
                  }
                  readOnly={true} />
                  )}
                </p>
                <p>
                  Town City: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_main_address_town_city"
                  defaultValue={
                    this.state.data.main_address.town_city
                  } />
                </p>
                <p>
                  County/Area: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_main_address_county_area"
                  defaultValue={
                    this.state.data.main_address.county_area
                  } />
                </p>
                <p>
                  Country: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_main_address_country"
                  defaultValue={
                    this.state.data.main_address.country
                  } />
                </p>
                <p>
                  Post Code: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_main_address_postcode"
                  defaultValue={
                    this.state.data.main_address.postcode
                  } />
                </p>
              </div>
              <div className="col-md-3 ">
                <h3>Invoice Address</h3>
                <p>
                  House Number or Name: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_invoice_address_house_number_or_name"
                  defaultValue={
                    this.state.data.invoice_address.house_number_or_name
                  } />
                </p>
                <p>
                  Address Line 1: {" "}
                  {window.hideSensitiveInfo ? (
                     <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_invoice_address_address_line_1"
                      defaultValue={
                        this.state.data.invoice_address.address_line_1
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            invoice_address: {
                              ...(this.state.data.invoice_address || {}),
                              address_line_1: e.target.value,
                            },
                          },
                        })
                      } />
                  ) : (
                    <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_invoice_address_address_line_1"
                  value={
                    maskName(this.state.data.invoice_address.address_line_1)
                  }
                  readOnly={true} />
                )}
                </p>
                <p>
                  Address Line 2: {" "}
                  {window.hideSensitiveInfo ? (
                     <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_invoice_address_address_line_2"
                      defaultValue={
                        this.state.data.invoice_address.address_line_2
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            invoice_address: {
                              ...(this.state.data.invoice_address || {}),
                              address_line_2: e.target.value,
                            },
                          },
                        })
                      } />
                  ) : (
                    <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_invoice_address_address_line_2"
                  value={
                    maskName(this.state.data.invoice_address.address_line_2)
                  }
                  readOnly={true} />
                )}
                </p>
                <p>
                  Address Line 3: {" "}
                  {window.hideSensitiveInfo ? (
                     <input
                      type="text"
                      className="form-control form-control-lg"
                      name="customer_invoice_address_address_line_3"
                      defaultValue={
                        this.state.data.invoice_address.address_line_3
                      }
                      onChange={(e) =>
                        this.setState({
                          data: {
                            ...this.state.data,
                            invoice_address: {
                              ...(this.state.data.invoice_address || {}),
                              address_line_3: e.target.value,
                            },
                          },
                        })
                      } />
                  ) : (
                    <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_invoice_address_address_line_3"
                  value={
                    maskName(this.state.data.invoice_address.address_line_3)
                  }
                  readOnly={true} />
                )}
                </p>
                <p>
                  Town City: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_invoice_address_town_city"
                  defaultValue={
                    this.state.data.invoice_address.town_city
                  } />
                </p>
                <p>
                  County/Area: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_invoice_address_county_area"
                  defaultValue={
                    this.state.data.invoice_address.county_area
                  } />
                </p>
                <p>
                  Country: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_invoice_address_country"
                  defaultValue={
                    this.state.data.invoice_address.country
                  } />
                </p>
                <p>
                  Post Code: <input
                  type="text"
                  className="form-control form-control-lg"
                  name="customer_invoice_address_postcode"
                  defaultValue={
                    this.state.data.invoice_address.postcode
                  } />
                </p>
              </div>
            </div>

            <hr />

            <div className="row">

              <div className="col-md-12 text-left">
                <h3>Defaults for New Jobs</h3>
              </div>
            </div>
            <div className="row text-center">
              <div className="col-md-2">
              Manual Appraisal Required From Driver App?
                <div className="btn-group btn-group-toggle"
                     id="manual-appraisal-required-from-driver-app-form-radio-container"
                     data-toggle="buttons">
                  <label
                    className={
                      "btn btn-secondary" +
                      (
                        this.state.data.apprisal_required_from_driver_app
                          ?
                          ' active '
                          : ''
                      )
                    }
                    id="yes-manual-appraisal-required-from-driver-app">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          this.state.data.apprisal_required_from_driver_app
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        this.state.data.apprisal_required_from_driver_app
                      )}
                      name="apprisal_required_from_driver_app"
                      readOnly
                      type="radio"
                      value="1"
                      required /> YES
                  </label>
                  <label className={
                    "btn btn-secondary"+
                    (
                      !this.state.data.apprisal_required_from_driver_app
                        ?
                        ' active '
                        : ''
                    )
                  }
                         id="no-manual-appraisal-required-from-driver-app">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          !this.state.data.apprisal_required_from_driver_app
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        !this.state.data.apprisal_required_from_driver_app
                      )}
                      name="apprisal_required_from_driver_app"
                      type="radio"
                      value="0"
                      readOnly
                      required /> NO
                  </label>
                </div>
              </div>
              <div className="col-md-2">
                Manual Appraisal Required?
                <div className="btn-group btn-group-toggle"
                     id="manual-appraisal-required-form-radio-container"
                     data-toggle="buttons">
                  <label
                    className={
                      "btn btn-secondary" +
                      (
                        this.state.data.manual_appraisal_required
                          ?
                          ' active '
                          : ''
                      )
                    }
                    id="yes-manual-appraisal-required">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          this.state.data.manual_appraisal_required
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        this.state.data.manual_appraisal_required
                      )}
                      name="manual_appraisal_required"
                      readOnly
                      type="radio"
                      value="1"
                      required /> YES
                  </label>
                  <label className={
                    "btn btn-secondary"+
                    (
                      !this.state.data.manual_appraisal_required
                        ?
                        ' active '
                        : ''
                    )
                  }
                         id="no-manual-appraisal-required">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          !this.state.data.manual_appraisal_required
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        !this.state.data.manual_appraisal_required
                      )}
                      name="manual_appraisal_required"
                      type="radio"
                      value="0"
                      readOnly
                      required /> NO
                  </label>
                </div>
              </div>

              <div className="col-md-2">
                Video Appraisal Required?
                <div className="btn-group btn-group-toggle"
                     id="video-appraisal-required-form-radio-container"
                     data-toggle="buttons">
                  <label
                    className={
                      "btn btn-secondary" +
                      (
                        this.state.data.video_appraisal_required
                          ?
                          ' active '
                          : ''
                      )
                    }
                    id="yes-video-appraisal-required">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          this.state.data.video_appraisal_required
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        this.state.data.video_appraisal_required
                      )}
                      name="video_appraisal_required"
                      readOnly
                      type="radio"
                      value="1"
                      required /> YES
                  </label>
                  <label className={
                    "btn btn-secondary"+
                    (
                      !this.state.data.video_appraisal_required
                        ?
                        ' active '
                        : ''
                    )
                  }
                         id="no-video-appraisal-required">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          !this.state.data.video_appraisal_required
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        !this.state.data.video_appraisal_required
                      )}
                      name="video_appraisal_required"
                      type="radio"
                      value="0"
                      readOnly
                      required /> NO
                  </label>
                </div>
              </div>
              <div className="col-md-3">
                Appraisal to be done on external system?
                <div
                  className="btn-group btn-group-toggle"
                  id="appraisal-to-be-done-on-external-system-form-radio-container"
                  data-toggle="buttons"
                >
                  <label
                    className={
                      "btn btn-secondary" +
                      (
                        this.state.data.
                          appraisal_to_be_done_on_external_system
                          ?
                          ' active '
                          : ''
                      )
                    }
                    id="yes-appraisal-to-be-done-on-external-system">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          this.state.data.
                            appraisal_to_be_done_on_external_system
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        this.state.data.
                          appraisal_to_be_done_on_external_system
                      )}
                      name="appraisal_to_be_done_on_external_system"
                      readOnly
                      type="radio"
                      value="1"
                      required /> YES
                  </label>
                  <label className={"btn btn-secondary"+
                  (
                    !this.state.data.
                      appraisal_to_be_done_on_external_system
                      ?
                      ' active '
                      : ''
                  )
                  }
                         id="no-appraisal-to-be-done-on-external-system">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          !this.state.data.
                            appraisal_to_be_done_on_external_system
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        !this.state.data.
                          appraisal_to_be_done_on_external_system
                      )}
                      name="appraisal_to_be_done_on_external_system"
                      type="radio"
                      value="0"
                      readOnly
                      required /> NO
                  </label>
                </div>
              </div>
              <div className="col-md-3">
                Name of external system for appraisal: <input
                type="text"
                name="name_of_external_system_for_appraisal"
                defaultValue={
                  this.state.data.name_of_external_system_for_appraisal
                } />
              </div>
              <div className="col-md-2">
                Collect Signature?
                <div
                  className="btn-group btn-group-toggle"
                  id="collect-signature-form-radio-container"
                  data-toggle="buttons"
                >
                  <label
                    className={"btn btn-secondary" +
                    (
                      this.state.data.collect_signature
                        ?
                        ' active '
                        : ''
                    )
                    }
                    id="yes-collect-signature">
                    <input
                      className={"form-control form-control-lg"+
                      (
                        this.state.data.collect_signature
                          ?
                          ' active '
                          : ''
                      )
                      }
                      defaultChecked={(
                        this.state.data.collect_signature
                      )}
                      name="collect_signature"
                      readOnly
                      type="radio"
                      value="1"
                      required /> YES
                  </label>
                  <label className={"btn btn-secondary"+
                  (
                    !this.state.data.collect_signature
                      ?
                      ' active '
                      : ''
                  )
                  }
                         id="no-collect-signature">
                    <input
                      className={"form-control form-control-lg"+
                      (
                        !this.state.data.collect_signature
                          ?
                          ' active '
                          : ''
                      )
                      }
                      defaultChecked={(
                        !this.state.data.collect_signature
                      )}
                      name="collect_signature"
                      type="radio"
                      value="0"
                      readOnly
                      required /> NO
                  </label>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>
                    Fuel Inclusive?
                  </label>

                  <div
                    className="btn-group btn-group-toggle"
                    id="driver-fuel-expense-included-in-job-price-form-radio-container"
                    data-toggle="buttons">
                    <label
                      className={"btn btn-secondary"+ (
                        this.state.data.
                          new_job_defaults_driver_fuel_expense_included_in_job_price
                          ? ' active '  : '')}
                      id="yes-driver-fuel-expense-included-in-job-price">
                      <input
                        className={"form-control form-control-lg "+ (
                          this.state.data.
                            new_job_defaults_driver_fuel_expense_included_in_job_price
                            ? ' active ' : '')}
                        name="driver_fuel_expense_included_in_job_price"
                        readOnly
                        defaultChecked={(
                          this.state.data.
                            new_job_defaults_driver_fuel_expense_included_in_job_price
                        )}
                        type="radio"
                        value="1"
                      /> YES
                    </label>
                    <label className={"btn btn-secondary"+
                    (
                      !this.state.data.
                        new_job_defaults_driver_fuel_expense_included_in_job_price
                        ?
                        ' active '
                        : ''
                    )
                    }
                           id="no-driver-fuel-expense-included-in-job-price">
                      <input className={"form-control form-control-lg"+
                      (
                        !this.state.data.
                          new_job_defaults_driver_fuel_expense_included_in_job_price
                          ?
                          ' active '
                          : ''
                      )
                      }
                             name="driver_fuel_expense_included_in_job_price"
                             readOnly
                             defaultChecked={(
                               !this.state.data.
                                 new_job_defaults_driver_fuel_expense_included_in_job_price
                             )}
                             type="radio" value="0" /> NO
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>
                    Fleet Paperwork required?
                  </label>

                  <div className="btn-group btn-group-toggle"
                       id="fleet-paperwork-form-radio-container"
                       data-toggle="buttons">

                    <label
                      className={"btn btn-secondary" + (
                        this.state.data.new_job_defaults_fleet_paperwork_required
                          ?
                          ' active '
                          : ''
                      )
                      }
                      id="yes-fleet-paperwork">
                      <input
                        className={"form-control form-control-lg" +
                        (
                          this.state.data.new_job_defaults_fleet_paperwork_required
                            ?
                            ' active '
                            : ''
                        )
                        }
                        defaultChecked={(
                          this.state.data.new_job_defaults_fleet_paperwork_required
                        )}
                        readOnly
                        name="vehicle_fleet_paperwork_required"
                        type="radio"
                        value="1"
                        required /> YES
                    </label>

                    <label className={"btn btn-secondary"  +
                    (
                      !this.state.data.new_job_defaults_fleet_paperwork_required
                        ?
                        ' active '
                        : ''
                    )
                    }
                           id="no-fleet-paperwork">
                      <input
                        className={"form-control form-control-lg" +  (
                          !this.state.data.new_job_defaults_fleet_paperwork_required
                            ?
                            ' active '
                            : ''
                        )
                        }
                        defaultChecked={(
                          !this.state.data.new_job_defaults_fleet_paperwork_required
                        )}
                        readOnly
                        name="vehicle_fleet_paperwork_required"
                        type="radio" value="0" required /> NO
                    </label>

                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group">
                  <label>
                    Jet Wash required?
                  </label>

                  <div className="btn-group btn-group-toggle"
                       id="jet-wash-form-radio-container"
                       data-toggle="buttons">

                    <label
                      className={"btn btn-secondary"  +
                      (
                        this.state.data.new_job_defaults_jet_wash_required
                          ?
                          ' active '
                          : ''
                      )
                      }
                      id="yes-jet-wash">
                      <input
                        className={"form-control form-control-lg"  +
                        (
                          this.state.data.new_job_defaults_jet_wash_required
                            ?
                            ' active '
                            : ''
                        )
                        }
                        defaultChecked={(
                          this.state.data.new_job_defaults_jet_wash_required
                        )}
                        readOnly
                        name="vehicle_jet_wash_required"
                        type="radio"
                        value="1"
                        required /> YES
                    </label>

                    <label
                      className={"btn btn-secondary"  +
                      (
                        !this.state.data.new_job_defaults_jet_wash_required
                          ?
                          ' active '
                          : ''
                      )
                      }
                      id="no-jet-wash">
                      <input
                        className={"form-control form-control-lg" +
                        (
                          !this.state.data.new_job_defaults_jet_wash_required
                            ?
                            ' active '
                            : ''
                        )
                        }
                        defaultChecked={(
                          !this.state.data.new_job_defaults_jet_wash_required
                        )}
                        readOnly
                        name="vehicle_jet_wash_required"
                        type="radio"
                        value="0"
                        required /> NO
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-md-2">
                <label>
                  Customer Provides Fuel Cost?
                </label><br />

                <div className="btn-group btn-group-toggle"
                     id="customer-provides-fuel-cost-form-radio-container"
                     data-toggle="buttons">
                  <label
                    className={"btn btn-secondary" +
                    (
                      this.state.data.
                        new_job_defaults_customer_provides_fuel_cost
                        ?
                        ' active '
                        : ''
                    )
                    }
                    id="yes-customer-provides-fuel-cost">
                    <input
                      className={"form-control form-control-lg"+
                      (
                        this.state.data.
                          new_job_defaults_customer_provides_fuel_cost
                          ?
                          ' active '
                          : ''
                      )
                      }
                      defaultChecked={(
                        this.state.data.
                          new_job_defaults_customer_provides_fuel_cost
                      )}
                      name="customer_provides_fuel_cost"
                      readOnly
                      type="radio"
                      value="1"
                      required /> YES
                  </label>
                  <label className={"btn btn-secondary"+
                  (
                    !this.state.data.
                      new_job_defaults_customer_provides_fuel_cost
                      ?
                      ' active '
                      : ''
                  )
                  }
                         id="no-customer-provides-fuel-cost">
                    <input
                      className={"form-control form-control-lg"+
                      (
                        !this.state.data.
                          new_job_defaults_customer_provides_fuel_cost
                          ?
                          ' active '
                          : ''
                      )
                      }
                      defaultChecked={(
                        !this.state.data.
                          new_job_defaults_customer_provides_fuel_cost
                      )}
                      name="customer_provides_fuel_cost"
                      type="radio"
                      value="0"
                      readOnly
                      required /> NO
                  </label>
                </div>
              </div>
              <div className="col-md-2">
                <label>
                  Customer Provides Mileage?
                </label><br />
                <div className="btn-group btn-group-toggle"
                     id="customer-provides-mileage-form-radio-container"
                     data-toggle="buttons">
                  <label
                    className={
                      "btn btn-secondary"+
                      (
                        this.state.data.
                          new_job_defaults_customer_provides_mileage
                          ?
                          ' active '
                          : ''
                      )
                    }
                    id="yes-customer-provides-mileage">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          this.state.data.
                            new_job_defaults_customer_provides_mileage
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        this.state.data.new_job_defaults_customer_provides_fuel_cost
                      )}
                      name="customer_provides_mileage"
                      readOnly
                      type="radio"
                      value="1"
                      required
                    /> YES
                  </label>
                  <label
                    className={
                      "btn btn-secondary"+
                      (
                        !this.state.data.
                          new_job_defaults_customer_provides_mileage
                          ?
                          ' active '
                          : ''
                      )
                    }
                    id="no-customer-provides-mileage">
                    <input
                      className={
                        "form-control form-control-lg"+
                        (
                          !this.state.data.
                            new_job_defaults_customer_provides_mileage
                            ?
                            ' active '
                            : ''
                        )
                      }
                      defaultChecked={(
                        this.state.data.
                          new_job_defaults_customer_provides_mileage
                      )}
                      name="customer_provides_mileage"
                      type="radio"
                      value="0"
                      readOnly
                      required /> NO
                  </label>
                </div>
              </div>
              <div className="col-md-2">
                <label>
                  Customer Provides Job Price?
                </label><br />
                <div
                  className="btn-group btn-group-toggle"
                  id="customer-provides-job-price-form-radio-container"
                  data-toggle="buttons"
                >
                  <label
                    className={
                      "btn btn-secondary"+
                      (
                        this.state.data.
                          new_job_defaults_customer_provides_job_price
                          ?
                          ' active '
                          : ''
                      )
                    }
                    id="yes-customer-provides-job-price">
                    <input className={
                      "form-control form-control-lg"+
                      (
                        this.state.data.
                          new_job_defaults_customer_provides_job_price
                          ?
                          ' active '
                          : ''
                      )
                    }
                           defaultChecked={(
                             this.state.data.
                               new_job_defaults_customer_provides_job_price
                           )}
                           name="customer_provides_job_price"
                           type="radio"
                           readOnly
                           value="1"
                           required
                    /> YES
                  </label>
                  <label
                    className={
                      "btn btn-secondary"+
                      (
                        !this.state.data.
                          new_job_defaults_customer_provides_job_price
                          ?
                          ' active '
                          : ''
                      )
                    }
                    id="no-customer-provides-job-price">
                    <input className={"form-control form-control-lg"+
                    (
                      !this.state.data.
                        new_job_defaults_customer_provides_job_price
                        ?
                        ' active '
                        : ''
                    )
                    }
                           defaultChecked={(
                             !this.state.data.
                               new_job_defaults_customer_provides_job_price
                           )}
                           name="customer_provides_job_price"
                           type="radio"
                           readOnly
                           value="0"
                           required
                    /> NO
                  </label>
                </div>
              </div>
                <div className="col-md-2">
                  <label>
                    Job Price Rounded Up?
                  </label><br />
                  <div
                    className="btn-group btn-group-toggle"
                    id="job-price-rounded-up-form-radio-container"
                    data-toggle="buttons"
                  >
                    <label
                      className={
                        "btn btn-secondary"+
                        (
                          this.state.data.
                            new_job_defaults_job_price_rounded_up
                            ?
                            ' active '
                            : ''
                        )
                      }
                      id="yes-job-price-rounded-up">
                      <input className={
                        "form-control form-control-lg"+
                        (
                          this.state.data.
                            new_job_defaults_job_price_rounded_up
                            ?
                            ' active '
                            : ''
                        )
                      }
                             defaultChecked={(
                               this.state.data.
                                 new_job_defaults_job_price_rounded_up
                             )}
                             name="job_price_rounded_up"
                             type="radio"
                             readOnly
                             value="1"
                             required
                      /> YES
                    </label>
                    <label
                      className={
                        "btn btn-secondary"+
                        (
                          !this.state.data.
                            new_job_defaults_job_price_rounded_up
                            ?
                            ' active '
                            : ''
                        )
                      }
                      id="no-job-price-rounded-up">
                      <input className={"form-control form-control-lg"+
                      (
                        !this.state.data.
                          new_job_defaults_job_price_rounded_up
                          ?
                          ' active '
                          : ''
                      )
                      }
                             defaultChecked={(
                               !this.state.data.
                                 new_job_defaults_job_price_rounded_up
                             )}
                             name="job_price_rounded_up"
                             type="radio"
                             readOnly
                             value="0"
                             required
                      /> NO
                    </label>
                </div>
              </div>
              <div className="col-md-2">
                  <label>
                    Is the customer to be charged VAT ?
                  </label><br />
                  <div
                    className="btn-group btn-group-toggle"
                    id="customer-vat-code-form-radio-container"
                    data-toggle="buttons"
                  >
                    <label
                      className={
                        "btn btn-secondary"+
                        (
                          this.state.data.customer_vat_code == 'ct1'
                            ?
                            ' active '
                            : ''
                        )
                      }
                      id="yes-customer-vat-code-form-radio-container">
                      <input className={
                        "form-control form-control-lg"+
                        (
                          this.state.data.customer_vat_code == 'ct1'
                            ?
                            ' active '
                            : ''
                        )
                      }
                             defaultChecked={(
                               this.state.data.customer_vat_code == 'ct1'
                             )}
                             name="customer_vat_code"
                             type="radio"
                             readOnly
                             value="ct1"
                             required
                      /> YES
                    </label>
                    <label
                      className={
                        "btn btn-secondary"+
                        (
                          this.state.data.customer_vat_code == 'ct0'
                            ?
                            ' active '
                            : ''
                        )
                      }
                      id="no-customer-vat-code-form-radio-container">
                      <input className={"form-control form-control-lg"+
                      (
                        this.state.data.customer_vat_code == 'ct0'
                          ?
                          ' active '
                          : ''
                      )
                      }
                             defaultChecked={(
                               this.state.data.customer_vat_code == 'ct0'
                             )}
                             name="customer_vat_code"
                             type="radio"
                             readOnly
                             value="ct0"
                             required
                      /> NO
                    </label>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="customer_needs_expenses">
                    The customer required the following documents.
                  </label>
                  <div className="btn-group btn-group-toggle"
                       id="customer-needs-expenses-form-radio-container"
                       data-toggle="buttons">
                    <label className={"btn btn-secondary"+
                        (
                          this.state.data.customer_requirement && this.state.data.customer_requirement.includes('pod')
                            ?
                            ' active '
                            : ''
                        )
                      }
                           id="pod-customer-needs-expenses">
                      <input className={"form-control form-control-lg"+
                        (
                          this.state.data.customer_requirement && this.state.data.customer_requirement.includes('pod')
                            ?
                            ' active '
                            : ''
                        )
                      }
                             name="customer_needs_expenses_pod"
                             type="checkbox" value="pod"/> POD
                    </label>
                    <label className={"btn btn-secondary"+
                        (
                          this.state.data.customer_requirement && this.state.data.customer_requirement.includes('poc')
                            ?
                            ' active '
                            : ''
                        )
                      }
                           id="poc-customer-needs-expenses">
                      <input className={"form-control form-control-lg"+
                        (
                          this.state.data.customer_requirement && this.state.data.customer_requirement.includes('poc')
                            ?
                            ' active '
                            : ''
                        )
                      }
                             name="customer_needs_expenses_poc"
                             type="checkbox" value="poc" /> POC
                    </label>
                    <label className={"btn btn-secondary"+
                        (
                          this.state.data.customer_requirement && this.state.data.customer_requirement.includes('fuel')
                            ?
                            ' active '
                            : ''
                        )
                      }
                           id="fuel-customer-needs-expenses">
                      <input className={"form-control form-control-lg"+
                        (
                          this.state.data.customer_requirement && this.state.data.customer_requirement.includes('fuel')
                            ?
                            ' active '
                            : ''
                        )
                      }
                             name="customer_needs_expenses_fuel"
                             type="checkbox" value="fuel" /> Fuel
                    </label>
                    <label className={"btn btn-secondary"+
                        (
                          this.state.data.customer_requirement && this.state.data.customer_requirement.includes('expense')
                            ?
                            ' active '
                            : ''
                        )
                      }
                           id="expeses-customer-needs-expenses">
                      <input className={"form-control form-control-lg"+
                        (
                          this.state.data.customer_requirement && this.state.data.customer_requirement.includes('expense')
                            ?
                            ' active '
                            : ''
                        )
                      }
                             name="customer_needs_expenses_all"
                             type="checkbox" value="expense" /> All Expenses
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="checkbox customer-archive-block">
                      <label>Is {this.state.data.name} Customer Archived?
                        <input type="checkbox" name="is_customer_archived" 
                          defaultValue={this.props.data.is_customer_archived}
                          defaultChecked={this.props.data.is_customer_archived}
                          onChange={(e) => this.handleChecked(e) }/>
                        <span className="cr">
                          <i className="cr-icon fa fa-check"></i>
                        </span>
                    </label>
                </div>
              </div>

              <div className="col-md-4">
                  <textarea className="form-control form-control-lg"
                        name="customer_disclaimer"
                        placeholder="Disclaimer"
                        style={{'marginTop':'50px'}}
                        id="customer_disclaimer"
                        defaultValue={this.state.data.disclaimer}>
                  </textarea>
              </div>

            </div>

            <hr />
            <div className="row">
              <div className="col-md-10">
                <h3>Customer Invoicing</h3>
                <div className="row text-center">
                  <div className="col-md-2">
                    Number of Jobs per invoice: <input
                    type="text"
                    name="number_of_jobs_per_invoice"
                    placeholder="any"
                    className="form-control form-control-lg"
                    defaultValue={
                      this.state.data.number_of_jobs_per_invoice
                    }
                  />
                  </div>
                  <div className="col-md-2">
                    Value of Jobs per invoice:
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.value_of_jobs_per_invoice_in_pence/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            value_of_jobs_per_invoice_in_pence: (
                              floatValue*100
                            )
                          });
                        }
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2">
                    Can be invoiced directly by ACV?
                    <div
                      className="btn-group btn-group-toggle"
                      id="can-be-invoiced-by-acv-form-radio-container"
                      data-toggle="buttons"
                    >
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            this.state.data.can_be_invoiced_by_acv
                              ?
                              ' active '
                              : ''
                          )}
                        id="yes-can-be-invoiced-by-acv">
                        <input className={
                          "form-control form-control-lg"+
                          (
                            this.state.data.can_be_invoiced_by_acv
                              ?
                              ' active '
                              : ''
                          )}
                              defaultChecked={(
                                this.state.data.
                                  can_be_invoiced_by_acv
                              )}
                              name="can_be_invoiced_by_acv"
                              type="radio"
                              readOnly
                              value="1"
                              required
                        /> YES
                      </label>
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            !this.state.data.
                              can_be_invoiced_by_acv
                              ?
                              ' active '
                              : ''
                          )}
                        id="no-can-be-invoiced-by-acv">
                        <input
                          className={
                            "form-control form-control-lg"+ (
                              !this.state.data.
                                can_be_invoiced_by_acv
                                ? ' active ' : '')}
                          defaultChecked={(
                            !this.state.data.
                              can_be_invoiced_by_acv
                          )}
                          name="can_be_invoiced_by_acv"
                          type="radio"
                          readOnly
                          value="0"
                          required
                        /> NO
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    Can be invoiced directly by BVL?
                    <div
                      className="btn-group btn-group-toggle"
                      id="can-be-invoiced-by-bvl-form-radio-container"
                      data-toggle="buttons"
                    >
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            this.state.data.can_be_invoiced_by_bvl
                              ?
                              ' active '
                              : ''
                          )}
                        id="yes-can-be-invoiced-by-bvl">
                        <input className={
                          "form-control form-control-lg"+
                          (
                            this.state.data.can_be_invoiced_by_bvl
                              ?
                              ' active '
                              : ''
                          )}
                              defaultChecked={(
                                this.state.data.
                                  can_be_invoiced_by_bvl
                              )}
                              name="can_be_invoiced_by_bvl"
                              type="radio"
                              readOnly
                              value="1"
                              required
                        /> YES
                      </label>
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            !this.state.data.
                              can_be_invoiced_by_bvl
                              ?
                              ' active '
                              : ''
                          )}
                        id="no-can-be-invoiced-by-bvl">
                        <input
                          className={
                            "form-control form-control-lg"+ (
                              !this.state.data.
                                can_be_invoiced_by_bvl
                                ? ' active ' : '')}
                          defaultChecked={(
                            !this.state.data.
                              can_be_invoiced_by_bvl
                          )}
                          name="can_be_invoiced_by_bvl"
                          type="radio"
                          readOnly
                          value="0"
                          required
                        /> NO
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    Can be invoiced directly by CND?
                    <div
                      className="btn-group btn-group-toggle"
                      id="can-be-invoiced-by-cnd-form-radio-container"
                      data-toggle="buttons"
                    >
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            this.state.data.can_be_invoiced_by_cnd
                              ?
                              ' active '
                              : ''
                          )}
                        id="yes-can-be-invoiced-by-cnd">
                        <input className={
                          "form-control form-control-lg"+
                          (
                            this.state.data.can_be_invoiced_by_cnd
                              ?
                              ' active '
                              : ''
                          )}
                              defaultChecked={(
                                this.state.data.
                                  can_be_invoiced_by_cnd
                              )}
                              name="can_be_invoiced_by_cnd"
                              type="radio"
                              readOnly
                              value="1"
                              required
                        /> YES
                      </label>
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            !this.state.data.
                              can_be_invoiced_by_cnd
                              ?
                              ' active '
                              : ''
                          )}
                        id="no-can-be-invoiced-by-cnd">
                        <input
                          className={
                            "form-control form-control-lg"+ (
                              !this.state.data.
                                can_be_invoiced_by_cnd
                                ? ' active ' : '')}
                          defaultChecked={(
                            !this.state.data.
                              can_be_invoiced_by_cnd
                          )}
                          name="can_be_invoiced_by_cnd"
                          type="radio"
                          readOnly
                          value="0"
                          required
                        /> NO
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    Can be invoiced directly by SCCD?
                    <div
                      className="btn-group btn-group-toggle"
                      id="can-be-invoiced-by-scv-form-radio-container"
                      data-toggle="buttons"
                    >
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            this.state.data.can_be_invoiced_by_scv
                              ?
                              ' active '
                              : ''
                          )}
                        id="yes-can-be-invoiced-by-scv">
                        <input className={
                          "form-control form-control-lg"+
                          (
                            this.state.data.can_be_invoiced_by_scv
                              ?
                              ' active '
                              : ''
                          )}
                              defaultChecked={(
                                this.state.data.
                                  can_be_invoiced_by_scv
                              )}
                              name="can_be_invoiced_by_scv"
                              type="radio"
                              readOnly
                              value="1"
                              required
                        /> YES
                      </label>
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            !this.state.data.
                              can_be_invoiced_by_scv
                              ?
                              ' active '
                              : ''
                          )}
                        id="no-can-be-invoiced-by-scv">
                        <input
                          className={
                            "form-control form-control-lg"+ (
                              !this.state.data.
                                can_be_invoiced_by_scv
                                ? ' active ' : '')}
                          defaultChecked={(
                            !this.state.data.
                              can_be_invoiced_by_scv
                          )}
                          name="can_be_invoiced_by_scv"
                          type="radio"
                          readOnly
                          value="0"
                          required
                        /> NO
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    Can be invoiced directly by G4?
                    <div
                      className="btn-group btn-group-toggle"
                      id="can-be-invoiced-by-g4-form-radio-container"
                      data-toggle="buttons"
                    >
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            this.state.data.can_be_invoiced_by_g4
                              ?
                              ' active '
                              : ''
                          )}
                        id="yes-can-be-invoiced-by-g4">
                        <input className={
                          "form-control form-control-lg"+
                          (
                            this.state.data.can_be_invoiced_by_g4
                              ?
                              ' active '
                              : ''
                          )}
                              defaultChecked={(
                                this.state.data.
                                  can_be_invoiced_by_g4
                              )}
                              name="can_be_invoiced_by_g4"
                              type="radio"
                              readOnly
                              value="1"
                              required
                        /> YES
                      </label>
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            !this.state.data.
                              can_be_invoiced_by_g4
                              ?
                              ' active '
                              : ''
                          )}
                        id="no-can-be-invoiced-by-g4">
                        <input
                          className={
                            "form-control form-control-lg"+ (
                              !this.state.data.
                                can_be_invoiced_by_g4
                                ? ' active ' : '')}
                          defaultChecked={(
                            !this.state.data.
                              can_be_invoiced_by_g4
                          )}
                          name="can_be_invoiced_by_g4"
                          type="radio"
                          readOnly
                          value="0"
                          required
                        /> NO
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    Can be invoiced directly by ACVTRUCK?
                    <div
                      className="btn-group btn-group-toggle"
                      id="can-be-invoiced-by-acvtruck-form-radio-container"
                      data-toggle="buttons"
                    >
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            this.state.data.can_be_invoiced_by_acvtruck
                              ?
                              ' active '
                              : ''
                          )}
                        id="yes-can-be-invoiced-by-acvtruck">
                        <input className={
                          "form-control form-control-lg"+
                          (
                            this.state.data.can_be_invoiced_by_acvtruck
                              ?
                              ' active '
                              : ''
                          )}
                              defaultChecked={(
                                this.state.data.
                                  can_be_invoiced_by_acvtruck
                              )}
                              name="can_be_invoiced_by_acvtruck"
                              type="radio"
                              readOnly
                              value="1"
                              required
                        /> YES
                      </label>
                      <label
                        className={
                          "btn btn-secondary"+
                          (
                            !this.state.data.
                              can_be_invoiced_by_acvtruck
                              ?
                              ' active '
                              : ''
                          )}
                        id="no-can-be-invoiced-by-acvtruck">
                        <input
                          className={
                            "form-control form-control-lg"+ (
                              !this.state.data.
                                can_be_invoiced_by_acvtruck
                                ? ' active ' : '')}
                          defaultChecked={(
                            !this.state.data.
                              can_be_invoiced_by_acvtruck
                          )}
                          name="can_be_invoiced_by_acvtruck"
                          type="radio"
                          readOnly
                          value="0"
                          required
                        /> NO
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-2" style={{borderLeft: "1px solid #9999996b"}}>
                <h3>Driver Recruitment </h3>
                <br/>
                <div className="row">
                  <div className="col-md-12">
                    <textarea rows="4" 
                    name="driver_video_link" 
                    placeholder="Add Video Link Here" 
                    className="form-control form-control-lg"
                    defaultValue={
                      this.state.data.driver_video_link
                    }></textarea>
                  </div>
                </div>
              </div> */}
            </div>
            
            <hr />
            <div className="row">
              <div className="col-md-12">
                <h3>Job Pricing Brackets</h3>
                <div className="row text-center">
                  <div className="col-md-3">
                    Mile Start
                  </div>
                  <div className="col-md-1">
                  </div>
                  <div className="col-md-3">
                    Mile End
                  </div>
                  <div className="col-md-1">
                  </div>
                  <div className="col-md-2">
                    Pence per Mile
                  </div>
                  <div className="col-md-2">
                    Fixed Price
                  </div>
                </div>
                <div className="row text-center">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      required name="pricing_mile_start_1"
                      defaultValue={
                        this.state.data.pricing_mile_start_1
                      }
                    />
                  </div>
                  <div className="col-md-1"> to </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={this.state.data.pricing_mile_end_1}
                      required name="pricing_mile_end_1" />
                  </div>
                  <div className="col-md-1"> = </div>
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={this.state.data.pricing_mile_pence_1}
                      required name="pricing_mile_pence_1" />
                  </div>
                  <div className="col-md-2">
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.pricing_mile_fixed_price_in_pence_1/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            pricing_mile_fixed_price_in_pence_1: (
                              floatValue * 100
                            ),
                          });
                        }
                      }
                    />
                  </div>
                </div>

                <div className="row text-center">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={
                        this.state.data.pricing_mile_start_2
                      }
                      name="pricing_mile_start_2" />
                  </div>
                  <div className="col-md-1"> to </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={
                        this.state.data.pricing_mile_end_2
                      }
                      name="pricing_mile_end_2" />
                  </div>
                  <div className="col-md-1"> = </div>
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={
                        this.state.data.pricing_mile_pence_2
                      }
                      name="pricing_mile_pence_2" />
                  </div>

                  <div className="col-md-2">
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.pricing_mile_fixed_price_in_pence_2/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            pricing_mile_fixed_price_in_pence_2: (
                              floatValue * 100
                            )
                          });
                        }
                      }
                    />
                  </div>
                </div>
                <div className="row text-center">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={this.state.data.pricing_mile_start_3}
                      name="pricing_mile_start_3"
                    />
                  </div>
                  <div className="col-md-1"> to </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={this.state.data.pricing_mile_end_3}
                      name="pricing_mile_end_3"
                    />
                  </div>
                  <div className="col-md-1"> = </div>
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={this.state.data.pricing_mile_pence_3}
                      name="pricing_mile_pence_3" />
                  </div>
                  <div className="col-md-2">
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.pricing_mile_fixed_price_in_pence_3/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            pricing_mile_fixed_price_in_pence_3: (
                              floatValue * 100
                            )
                          });
                        }
                      }
                    />
                  </div>
                </div>
                <div className="row text-center">
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={this.state.data.pricing_mile_start_4}
                      name="pricing_mile_start_4"
                    />
                  </div>
                  <div className="col-md-1"> to </div>
                  <div className="col-md-3">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={this.state.data.pricing_mile_end_4}
                      name="pricing_mile_end_4"
                    />
                  </div>
                  <div className="col-md-1"> = </div>
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control form-control-lg text-center"
                      defaultValue={this.state.data.pricing_mile_pence_4}
                      name="pricing_mile_pence_4"
                    />
                  </div>
                  <div className="col-md-2">
                    <CurrencyInput
                      type="text"
                      name="funds"
                      value={this.state.pricing_mile_fixed_price_in_pence_4/100}
                      prefix={'£'}
                      type='text'
                      allowNegative={true}
                      className="form-control form-control-lg form-control-currency"
                      onChangeEvent={
                        (event, maskedValue, floatValue) => {
                          this.setState({
                            pricing_mile_fixed_price_in_pence_4: (
                              floatValue * 100
                            ),
                          });
                        }
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <hr />
            <div className="row">
              <div className="col-md-2">
                Approved?
                <select
                  type="text"
                  name="customer_approved"
                  defaultValue={
                    this.state.data.is_approved ? 'yes' : 'no'
                  }>
                  <option value="no">No</option>
                  <option value="yes">Yes</option>
                </select>
              </div>
              <div className="col-md-2">
                Approved at: {this.state.data.approved_at}
              </div>
              <div className="col-md-2">
                Approved by: {this.state.data.approved_by_user_id}
              </div>
              <div className="col-md-2">
                <a className="btn btn-warning d-none" onClick={(e) => {this.handleShowStaff(e)}}> Show / Hide Staff</a>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-3">
                <button type="button" className="btn btn-info btn-lg" onClick={(e) => {this.showPricingHistory(e)}}>Pricing History</button>
              </div>
              <div className="col-md-2">
                <button type="button" className="btn btn-info btn-lg" onClick={(e) => {this.showCustomerAllUsers(e)}}>Show Customer All Users </button>
              </div>
            </div>
            { (this.state.showStaffUsers) ?  
            <div className="row">
              <div className="col-md-6">
                <h3>Users / Staff List</h3>
                <table className="table table-sm">
                <thead>
                  <tr>
                    <th>User ID</th>
                    <th>Name</th>
                    <th>Email</th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.state.data.users.map((user,index) => {
                    return (
                      <tr key={index}>
                        <td><a href={"/portal-admin/users/view/"+user.id}>{user.id}</a></td>
                        <td>{user.first_name} {user.last_name}</td>
                        <td>{user.email}</td>
                      </tr>
                    );
                  })}
                  </tbody> 
                </table>
              </div>
            </div>
            :null}   
            <br />
            <div
              className="text-center"
            >

              <button
                className="btn btn-lg btn-success"
                onClick={(e) => {
                  this.saveChangesToCustomer(e)
                }}>
                <i className="fa fa-save">
                </i>&nbsp;
                Save Changes to Customer Information
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    )
  }
}
